import "core-js/es/string";
import "core-js/es/array";
import "core-js/es/map";
import "core-js/es/set";
import "core-js/es/object";
import "core-js/es/promise";

import * as ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { initialize } from './initialize';
import { AppRoutes } from './Routes';

import { configureStore } from "./store/ui.settings/store";
import { useEffect, useState } from "react";
import { Authenticate } from "./Authentication";
import { BrowserRouter } from "react-router-dom";
import './styles/app.scss'

const container = document.getElementById("app") as HTMLElement;
const root = ReactDOM.createRoot(container);

const AppRoot = () => {
	const [store] = useState(configureStore());
	const [initialized, setInitialized] = useState(false);

	useEffect(() => {
		if (!initialized)
		{
			setInitialized(true)
			initialize();
		}
	}, [initialized]);

	return (
		<Provider store={store}>
			<Authenticate>
				<BrowserRouter>
					<AppRoutes />
				</BrowserRouter>
			</Authenticate>
		</Provider>
	);
};

root.render(<AppRoot/>);

